import React, { useState, useEffect, useContext } from "react";
import _ from "lodash";
import { toast } from "react-toastify";
import http from "../services/http";
import Input from "./common/input";
import Select from "./common/select";
import ListGroup from "./common/listGroup";
import UserContext from "../context/userContext";

const ManageGrabber = ({ match }) => {
  const [user] = useContext(UserContext);

  const [grabber, setGrabber] = useState({
    ID: "",
    REPORT_NAME: "",
    RCAT_ID: "",
    PRESENTATION_TYPE: "",
    REPORT_TYPE: "",
    PERD_CODE: "",
    ACCESS_LEVEL: "",
    SUPPRESS_BLANK_ROWS: "",
    LAST_UPDATED_DTS: "",
    LAST_UPDATED_BY: "",
  });
  const [parameters, setParameters] = useState([]);
  const [access, setAccess] = useState([]);
  const [categories, setCategories] = useState([]);
  const reportTypes = [
    { ID: 1, DESCRIPTION: "Personal" },
    { ID: 2, DESCRIPTION: "Shared" },
  ];
  const [code, setCode] = useState("");
  const [site, setSite] = useState({ id: "", name: "" });

  const sites = [
    { id: "BA", name: "Bardney" },
    { id: "BU", name: "Bury" },
    { id: "CA", name: "Cantley" },
    { id: "NE", name: "Newark" },
    { id: "WI", name: "Wissington" },
  ];

  useEffect(() => {
    async function getAccess() {
      try {
        const { data } = await http.get(`/data-access`);
        setAccess(data);
      }
      catch {
        //ignore error
      }
    }
    getAccess();
    document.title = "FTR - Manage Grabber";
    return () => {
      document.title = "FTR";
    };
  }, []);

  useEffect(() => {
    async function getCategories() {
      try {
        const { data } = await http.get(`/report-categories?ShowAll=true`);
        setCategories(data);
      }
      catch {
        //ignore error
      }
    }
    if (user) {
      getCategories();
      if (user.SITE !== "CO") setSite({ id: user.SITE });
    }
  }, [user]);

  useEffect(() => {
    async function getGrabber() {
      try {
        const { data } = await http.get(`/report/${match.params.id}`);
        setGrabber(data);
      }
      catch {
        //ignore error
      }
    }
    async function getParameters() {
      try {
        const { data } = await http.get(`/report-parameters/${match.params.id}`);
        setParameters(data);
      }
      catch {
        //ignore error
      }
    }
    if (user && match.params.id !== "New") {
      getGrabber();
      getParameters();
    }
  }, [user, match.params.id]);

  function handleChange({ currentTarget: input }) {
    // const newErrors = { ...errors };
    // const errorMessage = validateProperty(input, schema);
    // if (errorMessage) newErrors[input.name] = errorMessage;
    // else delete newErrors[input.name];
    // setErrors(newErrors);
    const newGrabber = { ...grabber };

    newGrabber[input.name] = input.value;

    if (newGrabber.RCAT_ID === '' || newGrabber.RCAT_ID === null)
      newGrabber.REPORT_TYPE = 1;

    console.log(newGrabber);
    setGrabber(newGrabber);
  }

  async function handleSave(e) {
    e.preventDefault();
    const submit = _.pick(grabber, [
      "REPORT_NAME",
      "ACCESS_LEVEL",
      "REPORT_TYPE",
      "RCAT_ID",
    ]);
    try {
      await http.put(`/grabber/${grabber.ID}`, submit);
      toast.success("Grabber Updated");
    } catch (ex) {
      if (ex.response) {
        toast.error(ex.response.data);
      }
    }
  }

  async function handleAdd(e) {
    e.preventDefault();

    if (!site.id) {
      return toast.error("invalid Site");
    }
    const submit = {
      REPT_ID: match.params.id,
      CODE: code.toUpperCase(),
      SITE: site.id,
    };

    try {
      const { data } = await http.post(`/report-parameters`, submit);
      setParameters([...parameters, data]);
    } catch (ex) {
      if (ex.response) {
        toast.error(ex.response.data);
      }
    }
  }

  async function handleSequenceUpdate(direction, parameter, index) {
    if (direction === "UP" && index === 0) return;
    if (direction === "DOWN" && index === parameters.length - 1) return;
    let offset = 0;
    if (direction === "UP") offset -= 1;
    if (direction === "DOWN") offset += 1;

    const Id = parameter.ID;
    const offsetId = parameters[index + offset].ID;

    try {
      await http.patch(`/report-parameters/sequence/${Id}/${offsetId}`);
      // Always update after database
      // Stops users from submitting another change without the previous one being complete
      const newParameters = [...parameters];
      const temp = newParameters[index + offset];
      const tempSeq = newParameters[index + offset].SEQ_NO;
      newParameters[index + offset] = newParameters[index];
      newParameters[index] = temp;
      // Swap Sequence Numbers here too
      newParameters[index].SEQ_NO = newParameters[index + offset].SEQ_NO;
      newParameters[index + offset].SEQ_NO = tempSeq;
      setParameters(newParameters);
    } catch (ex) {
      console.log(ex);
    }
  }

  async function handleDelete(parameter) {
    const oldParameters = [...parameters];
    setParameters(parameters.filter((p) => p.ID !== parameter.ID));
    try {
      await http.delete(`/report-parameters/${parameter.ID}`);
      toast.success(`Parameter ${parameter.CODE} Removed`);
    } catch (ex) {
      setParameters(oldParameters);
      if (ex.response) {
        toast.error(ex.response.data);
      }
    }
  }

  return (
    <div className="col mt-4">
      <form className="container">
        <div className="row">
          <div className="col">
            <Input
              name="REPORT_NAME"
              label="Grabber Name"
              placeholder="Name"
              value={grabber.REPORT_NAME}
              onChange={handleChange}
            />
          </div>
          <div className="col">
            <Select
              name="ACCESS_LEVEL"
              label="Access"
              placeholder="Level"
              options={access}
              value={grabber.ACCESS_LEVEL}
              onChange={handleChange}
              listKey="ID"
              listName="DESCRIPTION"
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <Select
              name="RCAT_ID"
              label="Category"
              placeholder="Category"
              options={[{ ID: "", NAME: "" }, ...categories]}
              value={grabber.RCAT_ID}
              onChange={handleChange}
              listKey="ID"
              listName="NAME"
            />
          </div>
          <div className="col">
            {/* Change to Option input? */}
            <Select
              name="REPORT_TYPE"
              label="Sharing"
              placeholder="Level"
              options={reportTypes}
              value={grabber.REPORT_TYPE}
              onChange={handleChange}
              listKey="ID"
              listName="DESCRIPTION"
              disabled={!user.MAINTAIN_GRABBERS || grabber.RCAT_ID === '' || grabber.RCAT_ID === null}
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <button className="btn btn-primary" onClick={handleSave}>
              Save
            </button>
          </div>
        </div>
        <hr className="bg-success" />
      </form>
      <form className="container mt-3">
        <div className="row">
          <div className="col">
            <ListGroup
              items={sites}
              onItemSelect={(e) => setSite(e)}
              selectedItem={site}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-auto">
            <Input
              name="Code"
              placeholder="Parameter Code"
              value={code}
              onChange={(e) => setCode(e.currentTarget.value)}
            />
          </div>
          <div className="col-auto">
            <button className="btn btn-primary" onClick={handleAdd}>
              Add
            </button>
          </div>
        </div>
      </form>
      <div className="row">
        <div className="col">
          <table className="table table-hover table-sm">
            <thead>
              <tr>
                <th>Code</th>
                <th>Heading 1</th>
                <th>Heading 2</th>
                <th>Heading 3</th>
                <th>Site</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {parameters.map((parameter, index) => (
                <tr key={parameter.ID}>
                  <td>{parameter.CODE}</td>
                  <td>{parameter.HEADING1}</td>
                  <td>{parameter.HEADING2}</td>
                  <td>{parameter.HEADING3}</td>

                  <td>{parameter.SITE}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-success mr-1"
                      onClick={() =>
                        handleSequenceUpdate("UP", parameter, index)
                      }
                    >
                      <i className="fas fa-arrow-up"></i>
                    </button>
                    <button
                      className="btn btn-sm btn-success ml-1"
                      onClick={() =>
                        handleSequenceUpdate("DOWN", parameter, index)
                      }
                    >
                      <i className="fas fa-arrow-down"></i>
                    </button>
                  </td>
                  {/* <td>
                    <button className="btn btn-primary btn-sm" onClick={handleUpdate}>Update</button>
                  </td> */}
                  <td>
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => handleDelete(parameter)}
                    >
                      <i className="fas fa-trash"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ManageGrabber;
